<template>
  <el-container class="content-wrap">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList='searchList' v-on:getSearchObj='getSearchObj'></publicExpandSearch>
    </div>
    <el-main style="padding: 0;">
      <BaseTable style="background-color: #fff;padding:16px 16px;margin: 0 17px;" :data="tableData"
        :column="userPlatForm == 'platForm' ? tabListL3Config : tabListL3Config1" pagination :auto-scroll="true"
        :total="totalPage" :page.sync="searchParams.current" @selection-change="selectionChange"
        :limit.sync="searchParams.size" @pagination="getList">
      </BaseTable>
    </el-main>
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="[`${imgBaseURL}${scopeItem.image}`]" />
    <Detial ref="detial" />
  </el-container>
</template>

<script>
import local from "@/utils/local.js";
import Detial from './prescriptionDetial';
import moment from 'moment';
import prescriptionConfig from './common/prescriptionConfig'
import { searchPrescription, prescriptionDetails, pushPurchaseRemind, remindApproval } from './api/orderPay'
import { imgBaseURL } from '@/utils/common'
import { platform, getHospitalList } from '@/api/doctorTeam'
const itemList = ['全部', '未购买', '已购买', '已失效']
export default {
  mixins: [prescriptionConfig],
  components: {
    Detial,
  },
  data() {
    return {
      searchParams: {
        current: 1,
        size: 10,
      },
      searchList: [
        {
          label: "姓名",
          paramName: "keyword",
          inputType: "input"
        },
        {
          label: "更新日期",
          paramName: "time",
          inputType: "datetimerange",
          paramstartTime: "prescriptionStartTime",
          paramEndTime: "prescriptionEndTime",
          isTime: true,
        },
        {
          label: "处方类型",
          paramName: "type",
          remote: false,
          inputType: "select",
          optionData: [
            {
              label: '西药处方',
              value: 1,
            },
            {
              label: '中药处方',
              value: 2,
            },
            {
              label: '营养处方',
              value: 3,
            },
            {
              label: '运动处方',
              value: 4,
            },
            {
              label: '治疗处方',
              value: 5,
            },
          ],
          remote: false
        },
        {
          label: "病人类型",
          paramName: "serviceSourceCode",
          remote: false,
          inputType: "select",
          optionData: [
            {
              label: '全病程',
              value: 1,
            },
            {
              label: '互联网医院',
              value: 2,
            },
          ],
          remote: false
        },
        {
          label: "审方状态",
          paramName: "status",
          inputType: "select",
          remote: false,
          optionData: [
            {
              label: '待审核',
              value: 1,
            },
            {
              label: '审核通过',
              value: 2,
            },
            {
              label: '审核驳回',
              value: 3,
            },
            {
              label: '审核过期',
              value: 4
            },
          ]
        },
        {
          label: "线下机构",
          paramName: "hospitalId",
          // inputType: "hospital",
          inputType: "hospital",
          optionData: [],
          remote: true
        }
      ],
      breadList: [{ name: '订单管理' }, { name: '电子处方' }],
      INDEX: '',
      orderDetails: {}, //订单详情 
      tableData: [],
      activeName: 'whole',
      totalPage: 0,
      drawerFlag: false,
      scopeItem: '', //点击的数据信息
      hospitalList: [], //医院列表
      imgBaseURL,
      showViewer: false,
      timer: null,
      userPlatForm: local.get('userPlatForm'),//平台：platForm 机构：organization  local.get('userPlatForm')
      orgName: local.get('orgName') ? local.get('orgName') : '',
    }
  },
  methods: {
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.init();
    },
    /**
     * @description: 查看大图
     * @param {*}
     * @return {*}
     */
    lookHandel() {
      window.open(process.env.VUE_APP_OSS_URL + this.orderDetails.pdf)
    },
    /**
     * @description: 提醒功能
     * @param {*}
     * @return {*}
     */
    reminderHandel(scope) {
      pushPurchaseRemind({
        id: scope.id
      }).then(res => {
        if (res.code == 0) {
          this.$message.success('提醒成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    remindApprovalHandel(scope) {
      remindApproval(scope.id).then(res => {
        if (res.code == 0) {
          this.init()
          this.$message.success('催审成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    selectionChange() { },
    getList() {
      this.init()
    },
    hometHandel(e) {
      this.$refs.detial.detial(e)
    },
    init(value) {
      searchPrescription(this.searchParams).then((res) => {
        if (res.code == 0) {
          //获取当前时间戳
          let nowTimes = Date.parse(new Date()) / 1000;
          this.tableData = res.data.records.map(item => {
            item.loseTime = moment(`${item.examineTime}`).add(1, 'days').format('YYYY-MM-DD HH:mm:ss')//审方时间+24小时 得到截止时期
            item.timestamp = parseInt(new Date(item.loseTime).getTime() / 1000 - nowTimes) > 0 ? parseInt(new Date(item.loseTime).getTime() / 1000 - nowTimes) : 0;
            return item
          })
          if (this.tableData.some(sub => sub.timestamp > 0)) {
            clearInterval(this.timer);
            this.timer = setInterval(() => {
              this.tableData = this.tableData.map(item => {
                if (item.timestamp > 0) {
                  item.timestamp--;
                  let result = parseInt(item.timestamp);
                  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
                  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
                  let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
                  item.times = h + `:${m}:${s}`;
                  return item
                } else {
                  item.timestamp = 0;
                  item.times = 0
                  return item;
                }
              })
            }, 1000);
          }
          this.totalPage = res.data.total
        }
      })
    },

    /**
     *  获取医院列表
     * 不携带参数获取所有
     * */
    getHospital() {
      getHospitalList({}).then((res) => {
        if (res.code == 0) {
          this.hospitalList = res.data
        }
      })
    },
  },
  created() {
    this.init()
    this.getHospital()
  },
  filters: {
    prescription(value) {
      switch (value * 1) {
        case 1:
          return '西药处方'
        case 2:
          return '中药处方'
        case 3:
          return '营养处方'
        case 4:
          return '运动处方'
        case 5:
          return '治疗处方'
      }
    },
    serviceCodeFilter(value) {
      switch (value * 1) {
        case 1:
          return '在线问诊'
        case 2:
          return '在线续方'
        case 3:
          return '在线随访'
        case 4:
          return '在线复诊'
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import './order.less';

.i-width {
  width: 330px
}

.s-width {
  width: 170px;
}
</style>
